import React from 'react';
import { Truck } from 'lucide-react';
import { formatMoney, shipping } from '../../lib/shopify';
interface ShippingMessageProps {
  /** Current cart subtotal — pass to show progress toward free shipping */
  subtotal?: number;
  className?: string;
}
export function ShippingMessage({
  subtotal,
  className = ''
}: ShippingMessageProps) {
  const threshold = shipping.freeShippingThreshold;
  const remaining = subtotal === undefined ? null : Math.max(0, threshold.amount - subtotal);
  const message = remaining === null ? `Free shipping over ${formatMoney(threshold.amount, threshold.currencyCode)}. ${shipping.note}` : remaining === 0 ? `Free shipping unlocked. ${shipping.note}` : `${formatMoney(remaining, threshold.currencyCode)} away from free shipping.`;
  return <p className={`flex items-center gap-2.5 text-sm text-white/55 ${className}`} data-id="element-289" data-mp="3eacntwfpnec3">
      <Truck size={16} className="shrink-0 text-beat-red" aria-hidden="true" data-id="element-290" data-mp="39d31ipnmbish" />
      {message}
    </p>;
}